import { render, staticRenderFns } from "./TransactionHistoryTable.vue?vue&type=template&id=0113f05e"
import script from "./TransactionHistoryTable.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports